import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';

import { apiClient } from 'api/apiClient';
import type { IRequestException } from 'api/types/requestException';

interface ICompleteSubscribeProps {
    csId: string;
}

interface ICompleteSubscribeResponse {
    message: string;
}

const completeSubscribe = async ({ csId }: ICompleteSubscribeProps) => {
    const response = await apiClient.post('subscribed', {
        json: {
            csId,
        },
        headers: {
            'Content-Type': 'application/json',
        },
    });

    return (await response.json()) as ICompleteSubscribeResponse;
};

export const useCompleteSubscribeMutation = (
    options: UseMutationOptions<
        ICompleteSubscribeResponse,
        IRequestException,
        ICompleteSubscribeProps
    >
) => {
    return useMutation(
        async (props) => await completeSubscribe(props),
        options
    );
};
